import React, { memo } from "react";
import BookingCard from "../BookingCard";
import { FloorplanBooking } from "../../floorplanTypes";

interface BanquetteTableProps {
  booking: FloorplanBooking | undefined;
  width: number;
  colour: string;
  rotation: number;
  isDark?: boolean;
}

const BanquetteTableComponent: React.FC<BanquetteTableProps> = ({
  booking,
  width,
  colour,
  rotation,
  isDark = false
}) => {
  return (
    <div
      className="absolute inset-0 rounded-2xl"
      style={{ backgroundColor: colour }}
    >
      <div
        className="absolute left-0 top-1 bottom-1 pointer-events-none"
        style={{
          width: "4px",
          backgroundColor: isDark
            ? "rgba(199, 210, 254, 0.3)"
            : "rgba(99, 102, 241, 0.4)",
          borderRadius: "4px 0 0 4px"
        }}
      />
      {booking && (
        <BookingCard
          booking={booking}
          rotation={rotation}
          shape="Rect"
          tableWidth={width}
        />
      )}
    </div>
  );
};

export const BanquetteTable = memo(BanquetteTableComponent);
